import type { UserCompanyPair } from './rosterMappedCompanies';
import { probeKryspaceWorkspaceSlug, type KryspaceSlugProbeResult } from '../services/probeKryspaceWorkspaceSlug';

export interface ReachableCompanyFilterResult {
  reachable: UserCompanyPair[];
  unreachable: UserCompanyPair[];
  uncertain: UserCompanyPair[];
  probes: KryspaceSlugProbeResult[];
}

/** Split roster rows by kryspace manifest reachability (parallel probe). */
export async function filterReachableKryspaceCompanies(
  rows: UserCompanyPair[]
): Promise<ReachableCompanyFilterResult> {
  const withSlug = rows.filter((row) => Boolean(row.company.kryspace_slug?.trim()));
  const withoutSlug = rows.filter((row) => !row.company.kryspace_slug?.trim());

  const probes = await Promise.all(
    withSlug.map(async (row) => {
      const slug = row.company.kryspace_slug!.trim();
      const probe = await probeKryspaceWorkspaceSlug(slug);
      return { row, probe };
    })
  );

  const reachable: UserCompanyPair[] = [...withoutSlug];
  const unreachable: UserCompanyPair[] = [];
  const uncertain: UserCompanyPair[] = [];

  for (const { row, probe } of probes) {
    if (probe.reachable && probe.probeUncertain) {
      uncertain.push(row);
      reachable.push(row);
    } else if (probe.reachable) {
      reachable.push(row);
    } else {
      unreachable.push(row);
    }
  }

  return { reachable, unreachable, uncertain, probes: probes.map((p) => p.probe) };
}
